"use client";

import { DynamicGamePlayer } from "@/components/feature/dynamic-game-player";
import { GameOrientationPrompt } from "@/components/feature/game-orientation-prompt";
import { FullscreenProvider } from "@/contexts/fullscreen-context";
import {
  GAME_THEATER_PLAYER_BACKGROUND,
  GAME_THEATER_PLAYER_BG_CLASS,
} from "@/lib/constants/layout";
import type { MobileOrientation } from "@/lib/schemas/game";

interface EmbeddableGame {
  id: string;
  name: string;
  slug: string;
  url: string | null;
  source_type: string | null;
  mobile_aspect_ratio?: string | null;
  mobile_orientation?: MobileOrientation | null;
  platform_event_tracking_enabled?: boolean;
}

interface GameEmbedViewProps {
  game: EmbeddableGame;
  className?: string;
  withFullscreenProvider?: boolean;
  fillContainer?: boolean;
}

export function GameEmbedView({
  game,
  className = "",
  withFullscreenProvider = true,
  fillContainer = false,
}: GameEmbedViewProps) {
  const content = (
    <div
      className={`relative w-full ${fillContainer ? `h-full ${GAME_THEATER_PLAYER_BG_CLASS}` : ""} ${className}`}
      style={fillContainer ? { backgroundColor: GAME_THEATER_PLAYER_BACKGROUND } : undefined}
    >
      <DynamicGamePlayer game={game} fillContainer={fillContainer} />
      <GameOrientationPrompt preference={game.mobile_orientation ?? "both"} />
    </div>
  );

  if (!withFullscreenProvider) {
    return content;
  }

  return <FullscreenProvider>{content}</FullscreenProvider>;
}
